import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Fancybox } from "@fancyapps/ui";
import axios from "axios";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DOMPurify from "dompurify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import CTA from "../components/cta"; 
function OffplanDetails()
{
   const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

    const { id } = useParams();
const currentUrl = window.location.href;
const [formData, setFormData] = useState({ 
  enqtyp: "",
  agent_name: "",
  agent_phone: "",
  agent_email: "" ,
  agent_address: "" 
});

const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState("");
const [responseMsg, setResponseMsg] = useState(""); 
const [responseType, setResponseType] = useState(""); // "success" | "error"
 const [property, setProperty] = useState(null); 
   const validate = () => {
  let err = {};

  if (!formData.agent_name.trim()) {
    err.agent_name = "Name is required";
  }

  if (!formData.agent_phone.trim()) {
    err.agent_phone = "Phone number is required";
  } else if (!/^[0-9+\s-]{7,15}$/.test(formData.agent_phone)) {
    err.agent_phone = "Invalid phone number";
  }

  if (!formData.agent_email) {
    err.agent_email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
    err.agent_email = "Invalid email address";
  }
 

  setErrors(err);

  return Object.keys(err).length === 0;
};
const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};
 const handleSubmit = async (e) => {
  e.preventDefault();
 const enqtyp = e.target.enqtyp.value;
  setSuccess("");

  if (!validate()) return;

  setLoading(true);

  try {
    const payload = {
      proref: property.title,
      pid: property.id,
      current_url: window.location.href,
      ...formData,
      enqtyp
    };

    const res = await axios.post(`${API}/api/EnquiryHandleroffplan.ashx`,
      JSON.stringify(payload),
      {
        headers: { "Content-Type": "application/json" }
      }
    );

    setSuccess("Message sent successfully!");
    setResponseType("success");
 setResponseMsg(res.data?.message || "Message sent successfully!");
    // reset form
    setFormData({ 
      enqtyp:"",
      agent_name: "",
      agent_phone: "",
      agent_email: "",
      agent_address: ""
    });

  } catch (err) { 
    setResponseType("error");
setResponseMsg("Something went wrong!");
  } finally {
    setLoading(false);
  }
};
  // ✅ Fetch API
  useEffect(() => {
    const fetchProperty = async () => {
      try {
        setLoading(true);

const res = await axios.post(`${API}/api/offplandetails.ashx`,
  {
    id: id   // ✅ correct
  },
  {
    headers: {
      "Content-Type": "application/json"
    }
  }
);
         setProperty(res.data.data[0]);
      } catch (error) {
        console.error("Error fetching property:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  }, [id]);

  // ✅ Initialize Fancybox after component mounts
useEffect(() => {
  if (!property) return;

  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Toolbar: { display: ["close"] },
  });

  return () => Fancybox.destroy();
}, [property]);
  if (!property) return <p>No property found</p>;
    return(
      <>
  <div
    className="off-banner"
    style={{
      backgroundImage:
        `url(${property.baner_image+'/w=1920,sharpen=1'})`
    }}
  >
    <div className="container">
      <div className="banner-off-content">
        <h1>{property.title}</h1>
        <h4>{property.subtitle}</h4>
        <br />
        <a
          data-bs-toggle="modal"
          data-bs-target="#demoModal"
          className="tf-btn-1 primary"
        >
          REGISTER INTEREST
        </a>
      </div>
    </div>
  </div>
  <section
    className="flat-section-v8 off-details-pgs-w"
    style={{ paddingBottom: 0, textAlign: "center" }}
  >
    <div className="container">
      <div className="tc ">
        
        <div
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.shortdescription),
  }}
/>
      </div>
      <div className="">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-md-4">
            <div className="ovrv-box">
              <h4 className="h4box">{property.paymentplan}</h4>
              <p>Payment plan</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="ovrv-box">
              <h4 className="h4box">{property.call_number}</h4>
              <p>Handover</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="ovrv-box">
              <h4 className="h4box">AED {property.displayprice}</h4>
              <p>Starting Price</p>
            </div>
          </div>
          <div className="col-md-5 mt-10">
            <div className="ovrv-box">
              <h4 className="h4box">{property.propertytype}</h4>
              <p>Property Type</p>
            </div>
          </div>
           <div className="col-md-5 mt-10">
            <div className="ovrv-box">
              <h4 className="h4box">{property.unittype.replace(/,/g, ", ")}</h4>
              <p>Unit Type</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className=" off-details-pgs-w off-bg-g">
    <div className="container">
      <div className="mn-img-bx">
        <div className="row" style={{ alignItems: "center" }}>
          <div className="col-md-6">
            <img src={'https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/'+property.snd_lft_img+'/w=745,sharpen=1'} />
          </div>
          <div className="col-md-6">
            <div className=" pr-50"> 
              <div
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.description).replace(/<h3>/g, '<h3 class="mb-25">'),
  }}
/>
              <div>
                <br />
              </div>
               
              <br />
              <a
                data-bs-toggle="modal"
                data-bs-target="#demoModal"
                className="tf-btn-1 primary"
              >
                REGISTER INTEREST
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="aminities">
    <div className="container">
      <div className="aminity-bx">
        <h3 className="mb-25" style={{ textAlign: "center" }}>
          Feature &amp; Amenities
        </h3>
        <div className="row" style={{ justifyContent: "center" }}>
        {property.amenities?.map((item, index) => (
    <div className="col-md-2 col-6" key={index} style={{ marginBottom: 20 }}> 
            <div className="am-bx">
              <img
                src={item.image+'/w=80,sharpen=1'}
                style={{ paddingBottom: 20, paddingTop: 10 }}
              />
              <div>{item.name}</div>
            </div>
          </div>
          ))}  
        </div>
      </div>
    </div>
  </section>
    <section className="flat-gallery-single">
  {(() => {
    const photos = [
      ...(property?.photos4 || []),
      ...(property?.photos5 || []),
    ].filter((p) => p?.image);

    const mainImage = photos[0];
    const remaining = photos.slice(1);

    return (
      <>
        {/* MAIN IMAGE */}
        
        {mainImage && (
          <div className="item1 box-img">
            <a
              href={`${mainImage.image}/w=900,sharpen=1`}
              data-fancybox="gallery"
              className="box-img"
            >
              <img
                src={`${mainImage.image}/w=941,sharpen=1`}
                alt="main-property"
              />
            </a>

            <div className="box-btn">
              <a
                href={`${mainImage.image}/w=900,sharpen=1`}
                data-fancybox="gallery"
                className="tf-btn primary fullborderradius"
              >
                View All Photos
              </a>
            </div>
          </div>
        )}

        {/* SHOW FIRST 4 ONLY */}
        {remaining.slice(0, 4).map((img, index) => (
          <a
            key={index}
            href={`${img.image}/w=900,sharpen=1`}
            className={`item${index + 2} box-img`}
            data-fancybox="gallery"
          >
            <img
              src={`${img.image}/w=468,sharpen=1`}
              alt={`gallery-${index}`}
            />
          </a>
        ))}

        {/* HIDDEN REST (still in Fancybox) */}
        {remaining.slice(4).map((img, index) => (
          <a
            key={`hidden-${index}`}
            href={`${img.image}/w=900,sharpen=1`}
            data-fancybox="gallery"
            style={{ display: "none" }}
          >
            <img src={`${img.image}/w=468,sharpen=1`} alt="" />
          </a>
        ))}
      </>
    );
  })()}
</section>
  <section
    className="flat-section-v8 off-details-pgs-w"
    style={{ backgroundColor: "#fff" }}
  >
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6">
          <h3 className="mb-25">Nearby Attractions</h3>
          <div className="row">
            {property.nearbyplace?.map((item, index) => (
    <div className="col-6" key={index}>  
              <div className="near-locations">
                <div className="nr-imgs">
                  <img src={item.image+'/w=50,sharpen=1'} />
                </div>
                <div>
                  <p>
                    <b>{item.amountpercent}</b>
                  </p>
                  <p>{item.title}</p>
                </div>
              </div>
            </div>
           ))} 
           </div>
        </div>
        <div className="col-md-6">
          <div className="brdr-r" style={{ overflow: "hidden" }}>
           <div
  className="map-container"
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.map, {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: ["src", "width", "height", "style"]
    })
  }}
/>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="px-10 pdg-50" style={{ backgroundColor: "#dbdbdb" }}>
  <div className="container">
    <h3 className="mb-25" style={{ textAlign: "center" }}>
      Floor Plan
    </h3>

    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      autoplay={{ delay: 3000 }}
      loop={true}
      spaceBetween={15}
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
    >
      {property?.floorplan?.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="emirate-card">
            <a
              href={`${item.image}/w=900,sharpen=1`}
              data-fancybox="floorplan"
            >
              <img
                src={`${item.image}/w=443,sharpen=1`}
                alt={`floorplan-${index}`}
              />
            </a>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>

    <br />

    <div style={{ textAlign: "center" }}>
      <a
        data-bs-toggle="modal"
        data-bs-target="#demoModalbro"
        className="tf-btn-1 primary"
      >
        DOWNLOAD BROCHURE
      </a>
    </div>
  </div>
</section>
  <section className=" off-details-pgs-w " style={{ backgroundColor: "#fff" }}>
    <div className="container">
      <div className="mn-img-bx">
        <div className="row">
          <div className="col-md-6">
            <div
              style={{
                  backgroundImage: `url("https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/${property.snd_background_banner}/w=841,sharpen=1")`,
                height: "100%",
                backgroundSize: "cover",
                overflow: "hidden"
              }}
            />
          </div>
          <div className="col-md-6">
            <div className="pdg-50" id="abtagent"> 
               <div
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(property.aboutlocation).replace(/<h3>/g, '<h3 class="mb-25">'),
  }}
/>
              <div>
                <br />
              </div>
               
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="flat-section-v8 pdg-50" style={{ backgroundColor: "#f8f8f8" }}>
    <div className="container">
      <h3 className="mb-25" style={{ textAlign: "center" }}>
        Payment plan
      </h3>
      <div className="row" style={{ justifyContent: "center" }}>
       {property.paymentplans?.map((item, index) => (
    <div className="col-md-3" key={index}>  
          <div className="ovrv-box">
            <h4>{item.amountpercent}%</h4>
            <p>{item.title}</p>
          </div>
        </div>
       ))} 
    </div>
    </div>
  </section>
    
  <div
    className="modal fade"
    id="demoModal"
    tabIndex={-1}
    aria-labelledby="demoModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content text-center p-3">
        <div className="modal-header">
          <h5 className="modal-title w-100" id="demoModalLabel">
            REGISTER NOW
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <form  className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="proref"
                  id="proref"
                  className="input"
                  defaultValue={property.reference_number}
                  style={{ width: "100%" }}
                />
                <input
  type="hidden"
  name="enqtyp"
  value="REGISTER NOW"
/> 
                
                <div className="ip-group">
                  <input
                    type="text"
                    name="agent_name"
                    id="agent_name"
                    value={formData.agent_name}
                    onChange={handleChange}
                    placeholder="Name"
                    className={`form-control ${errors.agent_name ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_name && (
    <p className="error-text">{errors.agent_name}</p>
  )}
                </div>
                <div className="ip-group">
                 <PhoneInput
  country={"ae"}   // default UAE 🇦🇪
  value={formData.agent_phone}
  onChange={(phone) =>
    setFormData({ ...formData, agent_phone: phone })
  }
  inputClass="form-control phone-input"
  containerClass="phone-container"
  enableSearch={true}
  placeholder="Enter phone number"
/>
                   {errors.agent_phone && (
    <p className="error-text">{errors.agent_phone}</p>
  )}
                </div>
                <div className="ip-group">
                  <input
                    type="email"
                    name="agent_email"
                    id="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    placeholder="Email"
                    className={`form-control ${errors.agent_phone ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_email && (
    <p className="error-text">{errors.agent_email}</p>
  )}
                </div>
                <div className="ip-group">
                 <textarea
  name="agent_address"
  id="agent_address"
  rows={4}
  placeholder="Message"
  value={formData.agent_address}
  onChange={handleChange}
  className="form-control"
  required
/>
                  <p className="error">{errors.agent_address}</p>
                </div>
                <div className="ip-group">
                {responseMsg && (
  <div className={`alert-box ${responseType}`}>
    {responseMsg}
  </div>
)}
                </div>
                <button
  type="submit"
  className="tf-btn-1 btn-view primary hover-btn-view w-100"
  disabled={loading}
>
  {loading ? "Sending..." : "Submit"}
  <span className="icon icon-arrow-right2" />
</button>
              </form>
      </div>
    </div>
  </div>
  <div
    className="modal fade"
    id="demoModalbro"
    tabIndex={-1}
    aria-labelledby="demoModalLabelbro"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content text-center p-3">
        <div className="modal-header">
          <h5 className="modal-title w-100" id="demoModalLabelbro">
            DOWNLOAD BROCHURE
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
         <form  className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="proref"
                  id="proref"
                  className="input"
                  defaultValue={property.reference_number}
                  style={{ width: "100%" }}
                /> 
                 <input
  type="hidden"
  name="enqtyp"
  value="DOWNLOAD BROCHURE"
/>
                <div className="ip-group">
                  <input
                    type="text"
                    name="agent_name"
                    id="agent_name"
                    value={formData.agent_name}
                    onChange={handleChange}
                    placeholder="Name"
                    className={`form-control ${errors.agent_name ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_name && (
    <p className="error-text">{errors.agent_name}</p>
  )}
                </div>
                <div className="ip-group">
                 <PhoneInput
  country={"ae"}   // default UAE 🇦🇪
  value={formData.agent_phone}
  onChange={(phone) =>
    setFormData({ ...formData, agent_phone: phone })
  }
  inputClass="form-control phone-input"
  containerClass="phone-container"
  enableSearch={true}
  placeholder="Enter phone number"
/>
                   {errors.agent_phone && (
    <p className="error-text">{errors.agent_phone}</p>
  )}
                </div>
                <div className="ip-group">
                  <input
                    type="email"
                    name="agent_email"
                    id="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    placeholder="Email"
                    className={`form-control ${errors.agent_phone ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_email && (
    <p className="error-text">{errors.agent_email}</p>
  )}
                </div>
                <div className="ip-group">
                 <textarea
  name="agent_address"
  id="agent_address"
  rows={4}
  placeholder="Message"
  value={formData.agent_address}
  onChange={handleChange}
  className="form-control"
  required
/>
                  <p className="error">{errors.agent_address}</p>
                </div>
                <div className="ip-group">
                  {responseMsg && (
  <div className="success-text">
    {responseMsg}
  </div>
)}
                </div>
                <button
  type="submit"
  className="tf-btn-1 btn-view primary hover-btn-view w-100"
  disabled={loading}
>
  {loading ? "Sending..." : "Submit"}
  <span className="icon icon-arrow-right2" />
</button>
              </form>
      </div>
    </div>
  </div>
  <CTA/>
</>

    )
}
    export default OffplanDetails;